<template>
  <div role="tablist" class="mt-3" id="listPedido">
    <div class="">
      <div class="">
        <!---- COLLAPSE GO SALES  --->
        <h5 class="txtLeft" style="border-bottom: 1px solid #cecece" v-if="this.statusX.length">Go Sales</h5>
        <b-card no-body class="mb-1 shadow b-radius-0" v-for="statusX in this.statusX" :key="statusX.codigo+'X'">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block  variant="secondary"  v-b-toggle="'collapseX' + statusX.codigo" >{{statusX.descricao}}</b-button>
          </b-card-header>
          <b-collapse :id="'collapseX' + statusX.codigo" accordion="my-accordion" role="tabpanel">
            <b-card>
              <b-card-text class="table">
                <b-table bordered striped :items="statusX.pedidos" :fields="fieldsPedidos" v-if="!empresaKatec">
                  <template slot="statusPedido" slot-scope="row">
                    {{row.item.status.descricao}}
                  </template>
                  <template slot="urlImagemCanal" slot-scope="row">
                    <img :src="row.item.canal.url" class="m-1">
                  </template>
                  <template slot="mobile" slot-scope="row">
                    <div class="form-row mb-1">
                      <div class="col-md-7"><strong>{{row.item.fantasia}}</strong></div>
                      <div class="col-md-5 txtRight"><strong>CÓD.: {{row.item.codCliente}}</strong></div>
                    </div>
                    <div class="form-row mb-1">
                      <div class="col-md-12"><strong>ID Gosales:</strong> {{row.item.id}}</div>
                    </div>
                    <div class="form-row mb-1">
                      <div class="col-md-6" v-if="row.item.emissao !== ''">Emissão: {{row.item.emissao}}</div>
                      <div class="col-md-6" v-else>Emissão: -</div>
                      <div class="col-md-6 txtRight">Status: </div>
                    </div>
                    <div class="form-row mb-1">
                      <div class="col-md-4 pedListImgMob"><img :src="row.item.canal.url" alt=""/></div>
                      <div class="col-md-8 mt-2 txtRight"><strong>R$ {{formatterValue(row.item.totalPedido)}}</strong></div>
                    </div>
                  </template>
                  <template slot="acao" slot-scope="row">
                    <b-button size="sm" @click="pageEdit(row.item, row.index)" class="mr-1">
                      {{row.item.isEditavel ? 'Editar' : 'Visualizar'}}
                    </b-button>
                  </template>
                </b-table>
                <b-table bordered striped :items="statusX.pedidos" :fields="fieldsPedidosKatec" v-else>
                  <template slot="statusPedido" slot-scope="row">
                    {{row.item.status.descricao}}
                  </template>
                  <template slot="urlImagemCanal" slot-scope="row">
                    <img :src="row.item.canal.url" class="m-1">
                  </template>
                  <template slot="mobile" slot-scope="row">
                    <div class="form-row mb-1">
                      <div class="col-md-7"><strong>{{row.item.fantasia}}</strong></div>
                      <div class="col-md-5 txtRight"><strong>CÓD.: {{row.item.codCliente}}</strong></div>
                    </div>
                    <div class="form-row mb-1">
                      <div class="col-md-12"><strong>ID Gosales:</strong> {{row.item.id}}</div>
                    </div>
                    <div class="form-row mb-1">
                      <div class="col-md-6" v-if="row.item.emissao !== ''">Emissão: {{row.item.emissao}}</div>
                      <div class="col-md-6" v-else>Emissão: -</div>
                      <div class="col-md-6 txtRight">Status: </div>
                    </div>
                    <div class="form-row mb-1">
                      <div class="col-md-4 pedListImgMob"><img :src="row.item.canal.url" alt=""/></div>
                      <div class="col-md-8 mt-2 txtRight"><strong>R$ {{formatterValue(row.item.totalPedido)}}</strong></div>
                    </div>
                  </template>
                  <template slot="acao" slot-scope="row">
                    <b-button size="sm" @click="pageEdit(row.item, row.index)" class="mr-1">
                      {{row.item.isEditavel ? 'Editar' : 'Visualizar'}}
                    </b-button>
                  </template>
                </b-table>
              </b-card-text>
            </b-card>
          </b-collapse>
        </b-card>
      </div>
      <br>
      <!------ COLLAPSE ERP ----------->
      <h5 v-if="this.status.length" class="txtLeft" style="border-bottom: 1px solid #cecece">ERP</h5>
      <b-card no-body class="mb-1 shadow b-radius-0" v-for="status in this.status" :key="status.codigo">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block  variant="secondary"  v-b-toggle="'collapse' + status.codigo" >{{status.descricao}}</b-button>
        </b-card-header>
        <b-collapse :id="'collapse' + status.codigo" accordion="my-accordion" role="tabpanel">
          <b-card>
            <b-card-text class="table">
              <b-table bordered striped :items="status.pedidos" :fields="fieldsPedidos" v-if="!empresaKatec">
                <template slot="statusPedido" slot-scope="row">
                  {{row.item.status.descricao}}
                </template>
                <template slot="urlImagemCanal" slot-scope="row">
                  <img :src="row.item.canal.url" class="m-1">
                </template>
                <template slot="mobile" slot-scope="row">
                  <div class="form-row mb-1">
                    <div class="col-md-7"><strong>{{toCapitalize(row.item.fantasia)}}</strong></div>
                    <div class="col-md-5 txtRight"><strong>Cód.: {{row.item.codCliente}}</strong></div>
                  </div>
                  <div class="form-row mb-1 w-100 pl-1 pr-1">{{toCapitalize(row.item.razaoSocial)}}</div>
                  <div class="form-row mb-1 w-100 pl-1 pr-1">{{row.item.cnpjCpf}}</div>
                  <div class="form-row mb-1">
                    <div class="col-md-8" v-if="row.item.numeroOrcamento !== ''">N. Orc: {{row.item.numeroOrcamento}}</div>
                    <div class="col-md-8" v-else>N. Orc: -</div>
                    <div class="col-md-4 txtRight" v-if="row.item.numeroPedido">N. Ped: {{row.item.numeroPedido}}</div>
                    <div class="col-md-4 txtRight" v-else>N. Ped: -</div>
                  </div>
                  <div class="form-row mb-1">
                    <div class="col-md-6" v-if="row.item.emissao !== ''">Emissão: {{row.item.emissao}}</div>
                    <div class="col-md-6" v-else>Emissão: -</div>
                    <div class="col-md-6 txtRight" v-if="row.item.numeroPedidoCompra !== ''">Ped. Compra: {{row.item.numeroPedidoCompra}}</div>
                    <div class="col-md-6 txtRight" v-else>Ped. Compra: -</div>
                  </div>
                  <div class="form-row mb-1">
                    <div class="col-md-4 pedListImgMob"><img :src="row.item.canal.url" alt="" /></div>
                    <div class="col-md-8 txtRight"><strong>R$ {{formatterValue(row.item.totalPedido)}}</strong></div>
                  </div>
                </template>
                <template slot="acao" slot-scope="row">
                  <b-button size="sm" @click="pageEdit(row.item, row.index)" class="mr-1">
                    {{row.item.isEditavel ? 'Editar' : 'Visualizar'}}
                  </b-button>
                </template>
              </b-table>
              <b-table bordered striped :items="status.pedidos" :fields="fieldsPedidosKatec" v-else>
                <template slot="statusPedido" slot-scope="row">
                  {{row.item.status.descricao}}
                </template>
                <template slot="urlImagemCanal" slot-scope="row">
                  <img :src="row.item.canal.url" class="m-1">
                </template>
                <template slot="mobile" slot-scope="row">
                  <div class="form-row mb-1">
                    <div class="col-md-7"><strong>{{toCapitalize(row.item.fantasia)}}</strong></div>
                    <div class="col-md-5 txtRight"><strong>Cód.: {{row.item.codCliente}}</strong></div>
                  </div>
                  <div class="form-row mb-1 w-100 pl-1 pr-1">{{toCapitalize(row.item.razaoSocial)}}</div>
                  <div class="form-row mb-1 w-100 pl-1 pr-1">{{row.item.cnpjCpf}}</div>
                  <div class="form-row mb-1">
                    <div class="col-md-8" v-if="row.item.numeroOrcamento !== ''">N. Orc: {{row.item.numeroOrcamento}}</div>
                    <div class="col-md-8" v-else>N. Orc: -</div>
                    <div class="col-md-4 txtRight" v-if="row.item.numeroPedido">N. Ped: {{row.item.numeroPedido}}</div>
                    <div class="col-md-4 txtRight" v-else>N. Ped: -</div>
                  </div>
                  <div class="form-row mb-1">
                    <div class="col-md-6" v-if="row.item.emissao !== ''">Emissão: {{row.item.emissao}}</div>
                    <div class="col-md-6" v-else>Emissão: -</div>
                    <div class="col-md-6 txtRight" v-if="row.item.numeroPedidoCompra !== ''">Ped. Compra: {{row.item.numeroPedidoCompra}}</div>
                    <div class="col-md-6 txtRight" v-else>Ped. Compra: -</div>
                  </div>
                  <div class="form-row mb-1">
                    <div class="col-md-4 pedListImgMob"><img :src="row.item.canal.url" alt="" /></div>
                    <div class="col-md-8 txtRight"><strong>R$ {{formatterValue(row.item.totalPedido)}}</strong></div>
                  </div>
                </template>
                <template slot="acao" slot-scope="row">
                  <b-button size="sm" @click="pageEdit(row.item, row.index)" class="mr-1">
                    {{row.item.isEditavel ? 'Editar' : 'Visualizar'}}
                  </b-button>
                </template>
              </b-table>
            </b-card-text>
          </b-card>
        </b-collapse>
      </b-card>
    </div>
    <span v-if="buscaVazia" class="card mb-5 shadow p-3">
      Não foram encontrados pedidos com os parâmetros pesquisados, por favor, tente novamente
    </span>
    <BlockUI v-if="blockUiVisibility" :message="msgBlockUi">
      <spinner-vue></spinner-vue>
    </BlockUI>
  </div>
</template>
<script>
  import tablePedidos from '@/services/tablePedidos'
  import { broadcastServer } from '@/main'
  import spinnerVue from '@/components/items/SpinnerVue'

  export default {
    name: 'TablePedidosVue',
    props: ['title'],
    components: {
      spinnerVue
    },
    data () {
      return {
        empresaKatec: false,
        blockUiVisibility: false,
        msgBlockUi: '',
        status: [],
        statusX: [],
        pedidosDoStatus: [],
        codStatusSelecionado: '',
        termo: '',
        codStatus: '',
        dataDe: '',
        dataAte: '',
        // Note 'isActive' is left out and will not appear in the rendered table
        fieldsPedidos: [
          {
            key: 'id',
            label: 'ID Gosales',
            sortable: true,
            class: 'txtLeft pedListFant'
          },
          {
            key: 'fantasia',
            label: 'Fantasia',
            sortable: true,
            class: 'txtLeft pedListFant',
            formatter: this.toCapitalize
          },
          {
            key: 'statusPedido',
            label: 'Status',
            sortable: true,
            class: 'pedListEmi'
          },
          {
            key: 'emissao',
            label: 'Emissão',
            sortable: true,
            class: 'pedListEmi'
          },
          {
            key: 'urlImagemCanal',
            label: 'Origem',
            sortable: false,
            class: 'pedListImg'
          },
          {
            key: 'totalPedido',
            label: 'Total',
            sortable: true,
            class: 'txtRight pedListTot',
            formatter: this.formatterValue
          },
          {
            label: '',
            key: 'mobile',
            class: 'pedListMobile txtLeft'
          },
          {
            label: 'Ação',
            key: 'acao',
            class: 'pedListAcoes'
          }
        ],
        fieldsPedidosKatec: [
          {
            key: 'id',
            label: 'ID Gosales',
            sortable: true,
            class: 'txtLeft pedListFant'
          },
          {
            key: 'fantasia',
            label: 'Cliente Reduzido',
            sortable: true,
            class: 'txtLeft pedListFant',
            formatter: this.toCapitalize
          },
          {
            key: 'statusPedido',
            label: 'Status',
            sortable: true,
            class: 'pedListEmi'
          },
          {
            key: 'emissao',
            label: 'Emissão',
            sortable: true,
            class: 'pedListEmi'
          },
          {
            key: 'urlImagemCanal',
            label: 'Origem',
            sortable: false,
            class: 'pedListImg'
          },
          {
            key: 'totalPedido',
            label: 'Total',
            sortable: true,
            class: 'txtRight pedListTot',
            formatter: this.formatterValue
          },
          {
            label: '',
            key: 'mobile',
            class: 'pedListMobile txtLeft'
          },
          {
            label: 'Ação',
            key: 'acao',
            class: 'pedListAcoes'
          }
        ],
        buscaVazia: false
      }
    },
    created () {
      let empresa = localStorage.getItem('empresaLogada')
      if (JSON.parse(empresa).identificador === 2355480534) {
        this.empresaKatec = true
      }
      broadcastServer.$on('filtrosSelecionados', (filtros, from) => {
        this.buscaVazia = false
        if (from === 0) {
          let objectPost = {
            termo: filtros.termo,
            codStatus: filtros.codStatus,
            emissaoDe: filtros.emissaoDe,
            emissaoAte: filtros.emissaoAte
          }
          // console.log(JSON.stringify(objectPost))
          this.msgBlockUi = 'Listando pedidos, por favor aguarde...'
          this.blockUiVisibility = true
          tablePedidos.listarPedidos(objectPost).then(response => {
            if (response.data.pedidosX.length === 0 && response.data.pedidos.length === 0) {
              this.buscaVazia = true
            } else {
              this.buscaVazia = false
            }
            this.status = this.montaPedidos(response.data.pedidos)
            this.statusX = this.montaPedidosX(response.data.pedidosX)
            // console.log(this.status)
            // this.status = this.status.pedidos.sort(function (a, b) {
            //   return a.id - b.id
            // })
            // this.statusX = this.statusX.pedidos.sort(function (a, b) {
            //   return a.id - b.id
            // })
          }).catch(error => {
            console.log(error)
            alert('Aconteceu alguma coisa!' + error)
          }).finally(() => {
            this.blockUiVisibility = false
          })
        } else {
          this.status = []
          this.statusX = []
        }
      })
    },
    mounted () {
      this.listarSelect()
      //  /api/private/v1/cliente/13121212/000564604540
    },
    methods: {
      montaPedidos: function (pedidos) {
        let statusPedidos = []
        let pedidosSemStatus = []
        for (var i = 0; i < pedidos.length; i++) {
          let pedido = pedidos[i]
          if (i === 0) {
            let status = Object.assign({}, (pedido.status))
            statusPedidos.push(status)
          } else {
            let statusExistentes = statusPedidos.filter(status => status.codigo === pedido.status.codigo)
            if (statusExistentes.length <= 0) {
              let status = Object.assign({}, (pedido.status))
              statusPedidos.push(status)
            }
          }
          // delete pedido.status
          pedidosSemStatus.push(pedido)
        }
        statusPedidos = statusPedidos.sort(function (a, b) {
          return a.ordem - b.ordem
        })
        for (var indice = 0; indice < statusPedidos.length; indice++) {
          let status = statusPedidos[indice]
          let pedidosDoStatus = pedidosSemStatus.filter(pedido => pedido.codStatus === status.codigo)
          statusPedidos[indice].pedidos = pedidosDoStatus
        }
        return statusPedidos
      },
      montaPedidosX: function (pedidos) {
        let statusPedidos = []
        let pedidosSemStatus = []
        pedidos = pedidos.sort(function (a, b) {
          return b.id - a.id
        })
        for (var i = 0; i < pedidos.length; i++) {
          let pedido = pedidos[i]
          if (i === 0) {
            let status = Object.assign({}, (pedido.status))
            statusPedidos.push(status)
          } else {
            let statusExistentes = statusPedidos.filter(status => status.codigo === pedido.status.codigo)
            if (statusExistentes.length <= 0) {
              let status = Object.assign({}, (pedido.status))
              statusPedidos.push(status)
            }
          }
          // delete pedido.status
          pedidosSemStatus.push(pedido)
        }
        statusPedidos = statusPedidos.sort(function (a, b) {
          return a.ordem - b.ordem
        })
        for (var indice = 0; indice < statusPedidos.length; indice++) {
          let status = statusPedidos[indice]
          let pedidosDoStatus = pedidosSemStatus.filter(pedido => pedido.codStatus === status.idStatus)
          statusPedidos[indice].pedidos = pedidosDoStatus
        }
        return statusPedidos
      },
      listarPedidos: function (objectPost) {
        tablePedidos.listarPedidos(objectPost).then(response => {
          this.status = response.data.pedidos
        })
      },
      listarSelect: function () {
        tablePedidos.listarSelect().then(response => {
          this.statusPedidos = response.data.statusPedidos
        })
      },
      pageEdit: function (pedido, index) {
        this.blockUiVisibility = true
        let param = {idPedido: pedido.id, isErp: pedido.isErp}
        tablePedidos.obterPedido(param).then(response => {
          broadcastServer.$emit('vizualizarPedido', '')
          let objPedido = { pedido: response.data.pedido, condPagtos: response.data.condPagtos }
          // console.log(objPedido)
          response.data.pedido.cliente.cnpjCpf = response.data.pedido.cliente.cnpjCpf.replace('.', '').replace('.', '').replace('.', '').replace('.', '').replace('/', '').replace('-', '').replace('-', '')
          broadcastServer.$emit('pedidoSelecionado', objPedido)
        }).catch(error => {
          console.log(error)
          alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUiVisibility = false
        })
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      formatterValue: function (valor) {
        let val = (valor / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    }
  }
</script>
<style scoped>
  .table {
    overflow-y: auto;
    max-height: 350px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/TablePedidosVue.vue